/* eslint-disable */
import select2 from '../util/select2.min.js'
import micromodal from '../util/micromodal.min.js'
import magnificPopup from '../util/magnificPopup.js'
import slick from '../util/slick.min.js';
import isotope from '../util/isotope.js';

export default {
	init() {
		// JavaScript to be fired on all pages

		/**
		 * Team filter with child categories.
		 */
		function ajax_team_filter() {
			var filter = $('.c-filter');
			var filterValueText = filter.find('option:selected').text();
			var teamHeader = filter.parent('.c-team--header').find('h2');

			$.ajax({
				url: filter.attr('action'),
				data: filter.serialize(),
				type: filter.attr('method'),
				success: function (data) {
					$('#response').html(data);
					teamHeader.text(filterValueText);
					if (filterValueText != 'Full Team') {
						$('.c-team--load-more').hide();
					} else {
						$('.c-team--load-more').show();
					}
					MicroModal.init({
						disableScroll: true,
						awaitCloseAnimation: true,
						openTrigger: 'data-custom-open',
						closeTrigger: 'data-custom-close'
					});
				}
			});
			return false;
		}
		$(function () {
			ajax_team_filter();
		});

		$('.c-filter select').on('change', function () {
			ajax_team_filter();

			MicroModal.init({
				disableScroll: true,
				awaitCloseAnimation: true,
				openTrigger: 'data-custom-open',
				closeTrigger: 'data-custom-close'
			});
		});

		if ($('.o-select2').length > 0) {
			$('.o-select2').select2({
				minimumResultsForSearch: -1
			});
		}

		window.almDone = function (alm) {
			alm.listing.classList.add('done');
		};

		window.almComplete = function () {
			MicroModal.init({
				disableScroll: true,
				awaitCloseAnimation: true,
				openTrigger: 'data-custom-open',
				closeTrigger: 'data-custom-close'
			});
		}

		// init Isotope
		var $grid = $('.c-job-openings__list').isotope({
			itemSelector: '.c-job',
			layoutMode: 'vertical',
			hiddenStyle: {
				opacity: 0,
				transform: 'scale(1)'
			},
			visibleStyle: {
				opacity: 1,
				transform: 'scale(1)'
			},
			transformsEnabled: false
		});



		//****************************
		// Isotope Load more button
		//****************************
		var initShow = 3; //number of items loaded on init & onclick load more button
		var counter = initShow; // counter for load more button
		var iso = $grid.data('isotope'); // get Isotope instance

		loadMore(initShow); //execute function onload

		// bind filter on select change
		$('.c-job-openings__team').on('change', function () {
			// get filter value from option value
			var filterValue = this.value;
			// use filterFn if matches value
			$grid.isotope({ filter: filterValue });
			loadMore(initShow); //execute function onload
		});

		function loadMore(toShow) {
			if (iso) {
				$grid.find(".u-active--off").removeClass("u-active--off");

				var hiddenElems = iso.filteredItems.slice(toShow, iso.filteredItems.length).map(function (item) {
					return item.element;
				});
				$(hiddenElems).addClass('u-active--off');
				$grid.isotope('layout');

				//when no more to load, hide show more button
				if (hiddenElems.length == 0) {
					jQuery("#load-more").hide();
				} else {
					jQuery("#load-more").show();
				};
			}
		}

		// append load more button
		$grid.after('<div class="o-button--tertiary c-job-openings__pagination js-jobs-pagination"><button class="o-button__link o-button-more" id="load-more"> Load More</button></div>');

		// when load more button clicked
		$("#load-more").click(function () {
			if ($('.c-job-openings__team').data('clicked')) {
				//when filter button clicked, set initial value for counter
				counter = initShow;
				$('.c-job-openings__team').data('clicked', false);
			} else {
				counter = counter;
			};
			counter = counter + initShow;

			loadMore(counter);
		});

		// when filter button clicked
		$(".c-job-openings__team").click(function () {
			$(this).data('clicked', true);

			loadMore(initShow);
		});

		/**
		 * Lever job postings feed.
		 */
		// function leverJobsInit() {
		//   // Location.
		//   var pageUrl = window.location.href;
		//   var pageSize = 8;
		//   var lastPage;
		//
		//   // Find last segment of URL.
		//   var pathArray = pageUrl.split( '/' );
		//   var lastSegment = pathArray[pathArray.length-2];
		//
		//   // Set 'team' variable for Lever URL.
		//   function getLeverTeam (pageSlug) {
		//     var pageTeamMap = {
		//       'research': 'research',
		//       'general': 'general',
		//       'clinical': 'clinical'
		//     };
		//     return (pageTeamMap[pageSlug] || pageTeamMap['default']);
		//   }
		//   var leverTeam = getLeverTeam(lastSegment);
		//   // Checking for potential Lever source or origin parameters.
		//   var leverParameter = '';
		//   var trackingPrefix = '?lever-';
		//
		//   // Selectors
		//   var $jobsContainer = $('#js-jobs-container');
		//   var $jobsTeam = $('.js-jobs-teams');
		//   var $jobsSort = $('.js-jobs-sort');
		//   var $jobsListContainer = $('.js-jobs-list');
		//   var $noJobResult = $('.js-jobs-list .no-job-result');
		//
		//   if ( pageUrl.indexOf(trackingPrefix) >= 0) {
		//     // Found Lever parameter.
		//     var pageUrlSplit = pageUrl.split(trackingPrefix);
		//     leverParameter = '?lever-'+pageUrlSplit[1];
		//   }
		//
		//   // Functions for checking if the variable is unspecified.
		//   function cleanString(string) {
		//     if (string) {
		//       var cleanString = string.replace(/\s+/ig, "");
		//       return cleanString;
		//     }
		//     else {
		//       return "Uncategorized";
		//     }
		//   }
		//
		//   function nullCheck(string) {
		//     if (!string) {
		//       return 'Uncategorized';
		//     }
		//     else {
		//       return string;
		//     }
		//   }
		//
		//   // function loadMore() {
		//   //   var loadmore = document.querySelector('#loadmore');
		//   //   var currentItems = 8;
		//   //   loadmore.addEventListener('click', (e) => {
		//   //     var elementList = document.querySelectorAll('.js-jobs-list .c-job');
		//   //     console.log(elementList.length);
		//   //     for (let i = currentItems; i < currentItems + 2; i++) {
		//   //       if (elementList[i]) {
		//   //         elementList[i].style.display = 'block';
		//   //       }
		//   //     }
		//   //     currentItems += 2;
		//   //     // Load more button will be hidden after list fully loaded
		//   //     if (currentItems >= elementList.length) {
		//   //       event.target.style.display = 'none';
		//   //     }
		//   //   });
		//   // }
		//
		//   function renderJobs(_data) {
		//     // Adding individual job postings.
		//     if (!_data.length){
		//       $jobsListContainer.html('<p class="no-job-result">No positions available.</p>');
		//     } else {
		//       var jobsList = [];
		//       var i;
		//       for (i = 0; i < _data.length; i++) {
		//         var posting = _data[i]
		//         var title = posting.text
		//         var location = nullCheck(posting.categories.location);
		//         var locationCleanString = cleanString(location);
		//         var commitment = nullCheck(posting.categories.commitment);
		//         var commitmentCleanString = cleanString(commitment);
		//         var team = nullCheck(posting.categories.team);
		//         var teamCleanString = cleanString(team);
		//         var link = posting.hostedUrl+leverParameter;
		//         var jobPosting = '<a href="'+link+'" class="c-job u-spacing--half" data-team="'+teamCleanString+'"><h3 class="c-job__title u-font--ml">'+title+'</h3><div class="c-job__tags o-heading--m"><span>'+location+'</span> - <span>'+commitment+'</span></div></a>';
		//         jobsList.push(jobPosting);
		//       }
		//       $jobsListContainer.html(jobsList.join(''));
		//     }
		//   }
		//
		//   function renderFilters(_data) {
		//     // Adding Team values to Team Sort select drop-downs.
		//     var teams = [];
		//     var i;
		//     for (i = 0; i < _data.length; i++) {
		//       var team = nullCheck(_data[i].categories.team);
		//       var teamCleanString = cleanString(team);
		//       var teamOption = '<option class="job-team '+teamCleanString+'">'+team+'</option>';
		//       // Check for duplicates.
		//       if (teams.indexOf(teamOption) === -1) {``
		//         teams.push(teamOption);
		//       }
		//       teams.sort();
		//     }
		//     $jobsTeam.append(teams.join(''));
		//   };
		//
		//   function fetchData(options, callback) {
		//     var leverUrl = 'https://api.lever.co/v0/postings/abatatherapeutics?mode=json';
		//     if (options.page) {
		//       leverUrl += '&limit=' + pageSize + '&skip=' + ((options.page - 1) * pageSize);
		//       if (!options.noCheckPagination) {
		//         lastPage = options.page;
		//       }
		//     }
		//     if (options.team) {
		//       leverUrl += '&team=' + options.team;
		//     }
		//     $.ajax({
		//       dataType: "json",
		//       url: leverUrl,
		//       success: function(data){
		//         if (!options.noCheckPagination && options.page) {
		//           checkPagination(options);
		//         }
		//         callback(data);
		//       },
		//       error: function() {
		//         $jobsListContainer.html('<p class="no-job-result">Content is not available.</p>');
		//       }
		//     });
		//   }
		//
		//   function checkPagination(options) {
		//     // Prev needs to be disabled on page 1.
		//     $('.js-jobs-pagination .o-button-prev').attr("disabled", lastPage <= 1);
		//     options.noCheckPagination = true;
		//     options.page += 1;
		//     fetchData(options, function(data) {
		//       if (!data.length) {
		//         $('.js-jobs-pagination .o-button-next').attr("disabled", true);
		//       } else {
		//         $('.js-jobs-pagination .o-button-next').attr("disabled", false);
		//       }
		//     });
		//   }
		//
		//   // Handlers for pagination buttons.
		//   function prevButton() {
		//     if (!$(this).attr('disabled') && lastPage > 1) {
		//       getLeverTeam(lastSegment);
		//       if (leverTeam == '') {
		//         var teamValue = $jobsTeam.val();
		//       } else {
		//         var teamValue = leverTeam;
		//       }  
		//       if (teamValue == "All") {
		//         teamValue = null;
		//       }
		//       $('html, body').animate({
		//         scrollTop: $jobsContainer.offset().top - 150
		//       }, 500);
		//       fetchData({team:teamValue, page: lastPage -= 1 }, function(data) {
		//         renderJobs(data);
		//       });
		//     }
		//   }
		//
		//   function nextButton() {
		//     if (!$(this).attr('disabled')) {
		//       getLeverTeam(lastSegment);
		//       if (leverTeam == '') {
		//         var teamValue = $jobsTeam.val();
		//       } else {
		//         var teamValue = leverTeam;
		//       }
		//       if (teamValue == "All") {
		//         teamValue = null;
		//       }
		//       $('html, body').animate({
		//         scrollTop: $jobsContainer.offset().top - 150
		//       }, 500);
		//       fetchData({team:teamValue, page: lastPage += 1 }, function(data) {
		//         renderJobs(data);
		//       });
		//     }
		//   }
		//
		//   // Sorting/Filters job postings triggered from select drop downs (team).
		//   function filterJobs() {
		//     var teamValue = $jobsTeam.val();
		//     var page = 1;
		//     if (teamValue == "All") {
		//       teamValue = null;
		//     }
		//     fetchData({team:teamValue, page: 1}, function(data) {
		//       renderJobs(data);
		//     });
		//   }
		//
		//   // Event Handlers (for pagination btns and drop-down filters)
		//   $('.js-jobs-pagination .o-button-prev').click(prevButton);
		//   $('.js-jobs-pagination .o-button-next').click(nextButton);
		//   $('.js-jobs-sort select').change(filterJobs);
		//
		//   // Init render filters.
		//   fetchData({}, function(data) {
		//     renderFilters(data);
		//   });
		//
		//   // Init render jobs.
		//   fetchData({page: 1, team: leverTeam}, function(data) {
		//     renderJobs(data);
		//   });
		// }

		// $(function() {
		//   leverJobsInit();
		// });

		/**
		 * General helper function to support toggle functions.
		 */
		var toggleClasses = function (element) {
			var $this = element,
				$togglePrefix = $this.data('prefix') || 'this';

			// If the element you need toggled is relative to the toggle, add the
			// .js-this class to the parent element and "this" to the data-toggled attr.
			if ($this.data('toggled') == "this") {
				var $toggled = $this.closest('.js-this');
			}
			else {
				var $toggled = $('.' + $this.data('toggled'));
			}
			if ($this.attr('aria-expanded', 'true')) {
				$this.attr('aria-expanded', 'true')
			}
			else {
				$this.attr('aria-expanded', 'false')
			}
			$this.toggleClass($togglePrefix + '-is-active');
			$toggled.toggleClass($togglePrefix + '-is-active');

			// Remove a class on another element, if needed.
			if ($this.data('remove')) {
				$('.' + $this.data('remove')).removeClass($this.data('remove'));
			}
		};

		/*
		 * Toggle Active Classes
		 *
		 * @description:
		 *  toggle specific classes based on data-attr of clicked element
		 *
		 * @requires:
		 *  'js-toggle' class and a data-attr with the element to be
		 *  toggled's class name both applied to the clicked element
		 *
		 * @example usage:
		 *  <span class="js-toggle" data-toggled="toggled-class">Toggler</span>
		 *  <div class="toggled-class">This element's class will be toggled</div>
		 *
		 */
		$('.js-toggle').on('click', function (e) {
			e.preventDefault();
			e.stopPropagation();
			toggleClasses($(this));
		});

		// Toggle parent class
		$('.js-toggle-parent').on('click', function (e) {
			e.preventDefault();
			var $this = $(this);
			$this.toggleClass('this-is-active');
			$this.parent().toggleClass('this-is-active');
		});

		// Prevent bubbling to the body. Add this class to the element (or element
		// container) that should allow the click event.
		$('.js-stop-prop').on('click', function (e) {
			e.stopPropagation();
		});

		// Toggle hovered classes
		$('.js-hover').on('mouseenter mouseleave', function (e) {
			e.preventDefault();
			e.stopPropagation();
			toggleClasses($(this));
		});

		$('.js-hover-parent').on('mouseenter mouseleave', function (e) {
			e.preventDefault();
			var $this = $(this);
			$this.toggleClass('this-is-active');
			$this.parent().toggleClass('this-is-active');
		});

		MicroModal.init({
			disableScroll: true,
			awaitCloseAnimation: true,
			openTrigger: 'data-custom-open',
			closeTrigger: 'data-custom-close'
		});

		new WOW().init();

		$('.o-timeline-popup-link').magnificPopup({
			type: 'inline',
			midClick: true,
			gallery: {
				enabled: true
			}
		});

		var magnificPopup = $.magnificPopup.instance;

		if ($('.c-timeline-popup__left-arrow')) {
			$('body').on('click', '.c-timeline-popup__left-arrow', function () {
				magnificPopup.prev();
			});
		};

		if ($('.c-timeline-popup__right-arrow')) {
			$('body').on('click', '.c-timeline-popup__right-arrow', function () {
				magnificPopup.next();
			});
		};

		// Scroll to target
		$('.scroll').on('click', function (e) {
			e.preventDefault();
			var offset = 150;
			var target = this.hash;
			if ($(this).data('offset') != undefined) offset = $(this).data('offset');
			$('html, body').stop().animate({
				'scrollTop': $(target).offset().top - offset
			}, 1000, 'swing', function () {
				// window.location.hash = target;
			});
		});

		$('#menuTrigger').click(function () {
			$('#menuTrigger').toggleClass('active');
			$('.c-menu--list').toggleClass("is-open");
			return false;
		});

		$('#subnavTrigger').click(function () {
			$('#subnavTrigger').toggleClass('active');
			$('#subnav').toggleClass("is-open");
			return false;
		});

		$('#subnav a').click(function () {
			$('#subnavTrigger').toggleClass('active');
			$('#subnav').removeClass("is-open");
			return false;
		});

		$('.c-testimonial').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			vertical: false,
			autoplay: false,
			infinite: false,
			fade: true,
			dots: true,
			centerMode: false,
			arrows: true,
			prevArrow: $('.c-testimonial__left-arrow'),
			nextArrow: $('.c-testimonial__right-arrow')
		});

	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js